import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Button } from "reactstrap";
import { Redirect } from "react-router-dom";
import DatePicker from "react-datepicker";
import Conversions from "../../../../Resources/Conversions";
import TimePicker from "rc-time-picker";
import { FaClock } from "react-icons/fa";
import { getAllResources } from "../../../../action/cultureAction";
import { Icon } from "semantic-ui-react";
import moment from "moment";
import CalendarGif from "../../../..//Assets/images/Calendar.gif";
import { getReportsList } from "action/ReportManagement/ManageReports";
import DataExportHeader from "./DataExportHeader";

const labelStyle = {
  marginRight: "4.5%",
  marginLeft: "1%",
  paddingLeft: "6%",
  fontWeight: "normal",
};

const startTimeMarginStyle = {
  display: "inline-block",
  marginLeft: "1%",
};

const endTimeMarginStyle = {
  display: "inline-block",
  marginLeft: "3%",
};

const pointerStyle = {
  pointerEvents: "none",
};

const cursorStyle = {
  cursor: "pointer",
};

const lineHeightStyle = {
  "line-height": "1.1",
};

const textlineStyle = {
  "line-height": "1.2",
};

class ExportFormat extends Component {
  componentWillMount() {
    this.props.onRef(this);
    if (
      this.props.getLabels === undefined ||
      this.props.getLabels["WorkOrders.Columns.Record.Text"] === undefined
    ) {
      this.props.getAllResources();
    }

    var SelectedReportDetails;
    SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
    if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
      this.SetDataToEdit(JSON.parse(SelectedReportDetails));
      this.setState({
        SelectedReportDetails: JSON.parse(SelectedReportDetails),
      });
    }

    /**
     * when the component mounts we check to see if the reducer/request has already been made
     * if it has been made we run our process to store the data in the array of strings. If it hasn't we run the
     * getReportsList()
     */
    if (this.props.ReportsList.length > 0) {
      var reportName = [];
      for (let index = 0; index < this.props.ReportsList.length; index++) {
        const element = this.props.ReportsList[index];
        reportName.push(element.name.toLowerCase().trim());
      }

      this.setState({
        reportNameValues: reportName,
      });
    } else {
      this.props.getReportsList();
    }
  }

  /**
   * we run component update to check if the props have been updated with the new data from getReportsList.
   * Implementing this just incase a user goes directly to the data export url without going through the
   * main report manager page.
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps) {
    if (this.props.ReportsList !== prevProps.ReportsList) {
      var reportName = [];
      for (let index = 0; index < this.props.ReportsList.length; index++) {
        const element = this.props.ReportsList[index];
        reportName.push(element.name.toLowerCase().trim());
      }
      this.setState({ reportNameValues: reportName });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      open2: false,
      redirectBack: false,
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(23, 59, 59, 59)),
      startTime: null,
      stopTime: null,
      disablestdRadio: false,
      disablecustomRadio: true,
      IsValid: true,
      IsNextDisabled: true,
      ExportFormatName: "",
      DescriptionValue: "",
      Is12HourFormat: true,
      reportPeriod: "0D",
      isCustomStartDateEmpty: false,
      isCustomEndDateEmpty: false,
      isCustomStartTimeEmpty: false,
      isCustomStopTimeEmpty: false,
      SelectedReportID: 0,
      SelectedReportDetails: "",
      defaultStandardChecked: true,
      defaultCustomChecked: false,
      defaultStandardValue: "0",
      isValidReportName: false,
      reportNameValues: [],
    };
    this.OnNext = this.OnNext.bind(this);
    this.OnCancel = this.OnCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleValueChange2 = this.handleValueChange2.bind(this);
    this.handleStdRadio = this.handleStdRadio.bind(this);
    this.handleCustomRadio = this.handleCustomRadio.bind(this);
    this.SetDataToEdit = this.SetDataToEdit.bind(this);
  }

  OnNext(tab) {
    let isValid = true;
    var startdate = this.state.startDate;
    var enddate = this.state.endDate;
    var starttime = this.state.startTime;
    var stoptime = this.state.stopTime;
    this.setState({
      IsValid: true,
      isCustomStartDateEmpty: false,
      isCustomEndDateEmpty: false,
      isCustomStartTimeEmpty: false,
      isCustomStopTimeEmpty: false,
    });
    //If report period is custom period then set custom start datetime and custom end datetime
    if (this.state.reportPeriod === "C") {
      if (
        startdate !== null &&
        enddate !== null &&
        starttime !== null &&
        stoptime !== null
      ) {
        var startDateTime = moment(
          startdate.toLocaleDateString() +
            new Date(starttime._d.getTime()).toString().split(" ")[4],
          "MM/DD/YYYYHH:mm:ss"
        );
        var customStartDateTime = new Date(
          startDateTime.format("YYYY-MM-DDTHH:mm:ss")
        );
        var endDateTime = moment(
          enddate.toLocaleDateString() +
            new Date(stoptime._d.getTime()).toString().split(" ")[4],
          "MM/DD/YYYYHH:mm:ss"
        );
        var customEndDateTime = new Date(
          endDateTime.format("YYYY-MM-DDTHH:mm:ss")
        );
        //Custom datetime validation
        if (customStartDateTime >= customEndDateTime) {
          isValid = false;
          this.setState({ IsValid: false });
        }
      } else {
        isValid = false;
        if (startdate === null) this.setState({ isCustomStartDateEmpty: true });
        if (enddate === null) this.setState({ isCustomEndDateEmpty: true });
        if (starttime === null) this.setState({ isCustomStartTimeEmpty: true });
        if (stoptime === null) this.setState({ isCustomStopTimeEmpty: true });
      }
    }
    if (isValid) {
      var exportFormatDetails = {
        ReportName: this.state.ExportFormatName,
        Description: this.state.DescriptionValue,
        ReportPeriod: this.state.reportPeriod,
        CustomStartDate:
          this.state.reportPeriod === "C" ? customStartDateTime : null,
        CustomEndDate:
          this.state.reportPeriod === "C" ? customEndDateTime : null,
        StartDate:
          this.state.reportPeriod === "C" ? customStartDateTime : startdate,
        EndDate: this.state.reportPeriod === "C" ? customEndDateTime : enddate,
      };
      this.props.toggle(tab);
      this.props.setExportFormat(exportFormatDetails);
    }
  }

  SetDataToEdit(data) {
    if (data !== undefined && data !== null) {
      var standardvalue = "0";
      var defaultstandardchecked = true; //standard
      var disablestdRadio = false,
        disablecustomRadio = true,
        startDate = new Date(),
        endDate = new Date(),
        defaultCustomChecked = false;
      var reportPeriod;
      switch (data.reportPeriod) {
        case "-1D":
          standardvalue = "2";
          this.handleStdDateChange("2");
          break;
        case "1W":
          standardvalue = "3";
          this.handleStdDateChange("3");
          break;
        case "-1W":
          standardvalue = "4";
          this.handleStdDateChange("4");
          break;
        case "1M":
          standardvalue = "5";
          this.handleStdDateChange("5");
          break;
        case "-1M":
          standardvalue = "6";
          this.handleStdDateChange("6");
          break;
        case "1Y":
          standardvalue = "7";
          this.handleStdDateChange("7");
          break;
        case "-1Y":
          standardvalue = "8";
          this.handleStdDateChange("8");
          break;
        case "0D":
          standardvalue = "1";
          this.handleStdDateChange("1");
          break;
        case "C":
          disablestdRadio = true;
          disablecustomRadio = false;
          startDate = data.startDate;
          endDate = data.endDate;
          defaultstandardchecked = false;
          defaultCustomChecked = true;
          reportPeriod = "C";
          var starthr = startDate.split("T")[1].split(":")[0];
          var startmin = startDate.split("T")[1].split(":")[1];
          var endhr = endDate.split("T")[1].split(":")[0];
          var endmin = endDate.split("T")[1].split(":")[1];
          //To Handle UTC Date
          var lStart_Date =
            new Date(startDate).getUTCFullYear() +
            "-" +
            (new Date(startDate).getUTCMonth() + 1) +
            "-" +
            new Date(startDate).getUTCDate();
          var lEnd_Date =
            new Date(endDate).getUTCFullYear() +
            "-" +
            (new Date(endDate).getUTCMonth() + 1) +
            "-" +
            new Date(endDate).getUTCDate();

          this.setState({
            startTime: moment().hour(starthr).minute(startmin).second(0),
            stopTime: moment().hour(endhr).minute(endmin).second(0),
            startDate: new Date(
              new Date(lStart_Date).setHours(starthr, startmin)
            ),
            endDate: new Date(new Date(lEnd_Date).setHours(endhr, endmin)),
            reportPeriod: reportPeriod,
          });
          break;
        default:
          break;
      }

      this.setState({
        ExportFormatName: data.name,
        DescriptionValue: data.description,
        IsNextDisabled: false,
        defaultStandardChecked: defaultstandardchecked,
        defaultStandardValue: standardvalue,
        disablestdRadio: disablestdRadio,
        disablecustomRadio: disablecustomRadio,
        defaultCustomChecked: defaultCustomChecked,
      });
    }
  }

  handleFilename(evt) {
    this.setState({ ExportFormatName: evt.target.value });
    var x = evt.target.value.toLowerCase().trim();

    if (x.length > 0) {
      if (!this.state.reportNameValues.includes(x)) {
        this.setState({
          IsNextDisabled: false,
        });
        this.setState({
          isValidReportName: false,
        });
      } else {
        this.setState({
          IsNextDisabled: true,
        });
        this.setState({
          isValidReportName: true,
        });
      }
    } else {
      this.setState({
        isValidReportName: false,
      });
      this.setState({
        IsNextDisabled: true,
      });
    }
  }

  handleDescription(desc) {
    this.setState({ DescriptionValue: desc.target.value });
  }

  handleStdRadio() {
    this.setState({
      disablecustomRadio: true,
      disablestdRadio: false,
      startTime: null,
      stopTime: null,
      IsValid: true,
      isCustomStartDateEmpty: false,
      isCustomEndDateEmpty: false,
      isCustomStartTimeEmpty: false,
      isCustomStopTimeEmpty: false,
    });
    this.handleStdDateChange(this.refs.user_in_Select_input.value);
  }

  handleStdDateChange(value) {
    var current = new Date();
    //yesterday
    if (value === "2") {
      let yesterday = new Date(current.setDate(current.getDate() - 1));
      let startofYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
      let endofYesterday = new Date(yesterday.setHours(23, 59, 59, 59));
      this.setState({
        startDate: startofYesterday,
        endDate: endofYesterday,
        reportPeriod: "-1D",
      });
    }
    //This Week
    else if (value === "3") {
      //This works fine only if start and end dates are in the same month. So comments below lines
      // let firstDayofWeek = new Date(current.setDate(current.getDate() - current.getDay() + 1));
      // let lastDayofWeek = new Date(current.setDate(current.getDate() - current.getDay() + 7));
      // let startofThisWeek = new Date(ThisWeekDates[0].setHours(0,0,0,0));
      // let endofThisWeek = new Date(ThisWeekDates[1].setHours(23,59,59,59));
      var currentWeekMonday = new Date().getDate() - new Date().getDay() + 1;
      let firstDayofWeek = new Date().setDate(currentWeekMonday);
      let lastDayofWeek = new Date().setDate(currentWeekMonday + 6);
      let startofThisWeek = new Date(
        new Date(firstDayofWeek).setHours(0, 0, 0, 0)
      );
      let endofThisWeek = new Date(
        new Date(lastDayofWeek).setHours(23, 59, 59, 59)
      );
      this.setState({
        startDate: startofThisWeek,
        endDate: endofThisWeek,
        reportPeriod: "1W",
      });
    }
    //Last Week
    else if (value === "4") {
      //This works fine only if start and end dates are in the same month. So comments below lines
      // let firstDayOfTheWeek = (current.getDate() - current.getDay()) + 1;
      // let lastDayOfTheWeek = firstDayOfTheWeek + 6;
      // let firstDayOfLastWeek = new Date(current.setDate(firstDayOfTheWeek - 7));
      // let lastDayOfLastWeek = new Date(current.setDate(lastDayOfTheWeek - 7));
      var currentWeekMonday1 = new Date().getDate() - new Date().getDay() + 1;
      var firstDayOfLastWeek = new Date().setDate(currentWeekMonday1 - 7);
      var lastDayOfLastWeek = new Date().setDate(currentWeekMonday1 - 1);
      let startofLastWeek = new Date(
        new Date(firstDayOfLastWeek).setHours(0, 0, 0, 0)
      );
      let endofLastWeek = new Date(
        new Date(lastDayOfLastWeek).setHours(23, 59, 59, 59)
      );
      this.setState({
        startDate: startofLastWeek,
        endDate: endofLastWeek,
        reportPeriod: "-1W",
      });
    }
    //This Month
    else if (value === "5") {
      let firstDayofMonth = new Date(
        current.getFullYear(),
        current.getMonth(),
        1
      );
      let lastDayofMonth = new Date(
        current.getFullYear(),
        current.getMonth() + 1,
        0
      );
      let startofThisMonth = new Date(firstDayofMonth.setHours(0, 0, 0, 0));
      let endofThisMonth = new Date(lastDayofMonth.setHours(23, 59, 59, 59));
      this.setState({
        startDate: startofThisMonth,
        endDate: endofThisMonth,
        reportPeriod: "1M",
      });
    }
    //Last Month
    else if (value === "6") {
      let firstDayofLastMonth = new Date(
        current.getFullYear(),
        current.getMonth() - 1,
        1
      );
      let lastDayofLastMonth = new Date(
        current.getFullYear(),
        current.getMonth(),
        0
      );
      let startofLastMonth = new Date(firstDayofLastMonth.setHours(0, 0, 0, 0));
      let endofLastMonth = new Date(
        lastDayofLastMonth.setHours(23, 59, 59, 59)
      );
      this.setState({
        startDate: startofLastMonth,
        endDate: endofLastMonth,
        reportPeriod: "-1M",
      });
    }
    //This Year
    else if (value === "7") {
      let firstDayofYear = new Date(current.getFullYear(), 0, 1);
      let lastDayofYear = new Date(current.getFullYear() + 1, 0, 0);
      let startofThisYear = new Date(firstDayofYear.setHours(0, 0, 0, 0));
      let endofThisYear = new Date(lastDayofYear.setHours(23, 59, 59, 59));
      this.setState({
        startDate: startofThisYear,
        endDate: endofThisYear,
        reportPeriod: "1Y",
      });
    }
    //Last Year
    else if (value === "8") {
      let firstDayofLastYear = new Date(current.getFullYear() - 1, 0, 1);
      let lastDayOfLastYear = new Date(current.getFullYear(), 0, 0);
      let startofLastYear = new Date(firstDayofLastYear.setHours(0, 0, 0, 0));
      let endofLastYear = new Date(lastDayOfLastYear.setHours(23, 59, 59, 59));
      this.setState({
        startDate: startofLastYear,
        endDate: endofLastYear,
        reportPeriod: "-1Y",
      });
    }
    //Today
    else {
      this.setState({
        startDate: new Date(new Date(current).setHours(0, 0, 0, 0)),
        endDate: new Date(new Date(current).setHours(23, 59, 59, 59)),
        reportPeriod: "0D",
      });
    }
  }

  handleCustomRadio() {
    this.setState({
      disablestdRadio: true,
      disablecustomRadio: false,
      startDate: new Date(),
      endDate: new Date(),
      reportPeriod: "C",
      startTime: moment().hour(0).minute(0).second(0),
      stopTime: moment().hour(23).minute(59).second(0),
    });
  }

  OnCancel() {
    this.setState({ redirectBack: true });
  }

  handleChange(date) {
    this.setState({ startDate: date });
  }

  handleChange2(date) {
    this.setState({ endDate: date });
  }

  handleValueChange = (value) => {
    this.setState({ startTime: value });
  };

  handleValueChange2 = (value) => {
    this.setState({ stopTime: value });
  };

  setOpen = ({ open }) => {
    this.setState({ open: true });
  };

  setClose = ({ open }) => {
    this.setState({ open: false });
  };

  setOpen2 = ({ open2 }) => {
    this.setState({ open2: true });
  };

  setClose2 = ({ open2 }) => {
    this.setState({ open2: false });
  };

  //Function to highlight the custom start time and custom end time textbox if empty or invalid.
  setCustomStyle = (id, invalid) => {
    var customDatePicker = document.getElementById(id);
    if (customDatePicker !== null) {
      if (invalid) customDatePicker.className = "rc-time-picker-error";
      else
        customDatePicker.className = this.state.disablecustomRadio
          ? "rc-time-picker-input"
          : "rc-time-picker-input white-bg";
    }
  };

  render(UserPreference_response, getLabels) {
    //let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
    if (this.state.redirectBack) {
      return <Redirect to="/ManageReports/ManageReportsDefinitions" />;
    }
    // let PreferedDateFormat = this.props.UserPreference_response;
    let Filters_in_Select_input;
    let label = this.props.getLabels;
    let Is12HrFormat = true;

    let PreferedDateFormat = this.props.UserPreference_response;
    let UserFormat =
      Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);

    if (PreferedDateFormat !== undefined) {
      if (PreferedDateFormat.timeFormatText !== "Time12HourFormat")
        Is12HrFormat = false;
    }

    if (label["DataExport.Filter.Options.Text"] !== undefined) {
      var Filetrs = label["DataExport.Filter.Options.Text"].split(",");
      Filters_in_Select_input = Filetrs.map((el, index) => (
        <option
          id={index}
          value={el}
          selected={el === this.state.defaultStandardValue ? true : false}
        >
          {label["DataExport.Filter.Options." + el + ".Text"]}
        </option>
      ));
    }

    // highlight custom start time text box if empty
    if (this.state.isCustomStartTimeEmpty || !this.state.IsValid) {
      this.setCustomStyle("ExFStartTime", true);
    } else {
      this.setCustomStyle("ExFStartTime", false);
    }

    //highlight custom end time text box if empty
    if (this.state.isCustomStopTimeEmpty || !this.state.IsValid) {
      this.setCustomStyle("ExFStopTime", true);
    } else {
      this.setCustomStyle("ExFStopTime", false);
    }

    return (
      <div id="ExportFormat" style={lineHeightStyle}>
        {/*Header Section*/}
        <FormGroup row>
          <DataExportHeader  />
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <Label className="dataexportheaderlbl">Export Details</Label>
          </Col>
        </FormGroup>
        <hr />

        <FormGroup row style={textlineStyle}>
          <Icon
            name="exclamation triangle"
            style={
              this.state.IsValid && !this.state.isCustomStartDateEmpty
                ? { display: "none" }
                : {
                    color: "red",
                    "padding-left": "17px",
                    "padding-right": "20px",
                    "padding-top": "0px",
                  }
            }
          />
          <Label
            style={
              this.state.IsValid && !this.state.isCustomStartDateEmpty
                ? { display: "none" }
                : {}
            }
            className="workorderheaderlbl"
          >
            Error: You left necessary fields blank or entered invalid values.
            Review and correct any fields with "!" next to them.
          </Label>
          <Col sm={{ size: 12 }}>
            <Label style={{ float: "left" }} className="workorderlbl">
              Report Name
            </Label>
          </Col>
          <Col sm={{ size: 12 }}>
            <input
              type="text"
              ref="name_in_input"
              maxLength={"50"}
              id="Filename"
              onChange={(evt) => this.handleFilename(evt)}
              style={{ width: "50%" }}
              className={"dataexport-textbox"}
              value={this.state.ExportFormatName}
            />
          </Col>
          <Icon
            name="exclamation triangle"
            style={
              this.state.isValidReportName
                ? {
                    color: "red",
                    "padding-left": "17px",
                    "padding-right": "20px",
                    "padding-top": "0px",
                  }
                : { display: "none" }
            }
          />
          <Label
            style={this.state.isValidReportName ? {} : { display: "none" }}
            className="workorderheaderlbl"
          >
            Report Name already exists.
          </Label>
        </FormGroup>

        {/*description field */}
        <FormGroup row style={textlineStyle}>
          <Col sm={{ size: 12 }}>
            <Label style={{ float: "left" }} className="workorderlbl">
              Description
            </Label>
          </Col>
          <Col sm={{ size: 12 }}>
            <textarea
              aria-label="data export report description"
              rows="3"
              type="text"
              ref="DE_description_input"
              maxLength={"90"}
              id="descriptionField"
              onChange={(desc) => this.handleDescription(desc)}
              style={{ width: "50%", resize: "none" }}
              className={"dataExportDesc-textarea"}
              value={this.state.DescriptionValue}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <Label style={{ float: "left" }} className="workorderlbl">
              Time Period
            </Label>
          </Col>
          <Col sm={{ size: 12 }}>
            <input
              type="radio"
              ref="Standard"
              name="rdRequestType"
              value="0"
              defaultChecked={this.state.defaultStandardChecked}
              onChange={this.handleStdRadio}
              className="workorderlbl"
            />
            {"     "}
            <Label
              className="workorderheaderlbl"
              style={{ marginRight: "4.5%", marginLeft: "1%" }}
            >
              Standard
            </Label>
            <select
              ref="user_in_Select_input"
              className={"minimal workorderedit-dropdown"}
              disabled={this.state.disablestdRadio}
              style={
                this.state.disablestdRadio
                  ? { width: "28%", color: "gray", pointerEvents: "none" }
                  : { width: "28%", color: "gray", backgroundColor: "#FFFFFF" }
              }
              onChange={(e) => {
                this.handleStdDateChange(e.target.value);
              }}
            >
              {Filters_in_Select_input}
            </select>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <input
              type="radio"
              ref="Custom"
              defaultChecked={this.state.defaultCustomChecked}
              name="rdRequestType"
              value="1"
              onChange={this.handleCustomRadio}
              className="workorderlbl"
            />
            {"     "}
            <Label className="workorderheaderlbl" style={{ marginLeft: "1%" }}>
              Custom
            </Label>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={{ size: 6 }}>
            <Label style={labelStyle} className="workorderlbl">
              Start Date
            </Label>
            <div
              className={"workorderheaderlbl"}
              style={
                this.state.disablecustomRadio
                  ? { ...pointerStyle, ...startTimeMarginStyle }
                  : startTimeMarginStyle
              }
            >
              <label style={cursorStyle}>
                <DatePicker
                  id="ExpStartDate"
                  selected={
                    this.state.disablestdRadio ? this.state.startDate : null
                  }
                  minDate={this.state.ServerTime}
                  onChange={this.handleChange}
                  dateFormat={UserFormat}
                  utcOffset={0}
                  showDisabledMonthNavigation
                  value={this.state.startDate}
                  className={
                    this.state.disablecustomRadio
                      ? "workorderedit-dropdown pm_bg_color Pm_Full_Width"
                      : !this.state.isCustomStartDateEmpty && this.state.IsValid
                      ? "workorderedit-dropdown Pm_Full_Width"
                      : "errorhighlight workorderedit-dropdown Pm_Full_Width"
                  }
                />

                <img
                  src={CalendarGif}
                  alt="Trane Logo"
                  className="link_cursor"
                  style={{ paddingLeft: "10px" }}
                />
              </label>
            </div>
            <Icon
              name="exclamation triangle"
              style={
                this.state.IsValid && !this.state.isCustomStartDateEmpty
                  ? { display: "none" }
                  : {
                      color: "red",
                      "padding-left": "8px",
                      "padding-right": "14px",
                      "padding-top": "4px",
                    }
              }
            />
          </Col>
          <Col sm={{ size: 6 }}>
            <Label style={labelStyle} className="workorderlbl">
              Start Time
            </Label>
            <label
              style={
                this.state.disablecustomRadio
                  ? { ...pointerStyle, ...cursorStyle, ...startTimeMarginStyle }
                  : { ...cursorStyle, ...startTimeMarginStyle }
              }
              className={
                this.state.IsValid && !this.state.isCustomStartTimeEmpty
                  ? ""
                  : "errorhighlight"
              }
            >
              <TimePicker
                ref="Time_in_timepicker"
                id="ExFStartTime"
                onChange={this.handleValueChange}
                use12Hours={Is12HrFormat}
                format={Is12HrFormat ? "h:mm A" : "HH:mm"}
                value={this.state.startTime}
                showSecond={false}
                open={this.state.open}
                onOpen={this.setOpen}
                onClose={this.setClose}
                style={{ width: "100%" }}
                focusOnOpen
              />
              <div className="pm_timerdiv" style={{ marginTop: "-12%" }}>
                <FaClock
                  className="pm_calendarbox"
                  width="17px"
                  height="17px"
                />
              </div>
            </label>
            <Icon
              name="exclamation triangle"
              style={
                this.state.IsValid && !this.state.isCustomStartTimeEmpty
                  ? { display: "none" }
                  : {
                      color: "red",
                      "padding-left": "8px",
                      "padding-right": "14px",
                      "padding-top": "0px",
                    }
              }
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={{ size: 6 }}>
            <Label style={labelStyle} className="workorderlbl">
              End Date
            </Label>
            <div
              className={"workorderheaderlbl"}
              style={
                this.state.disablecustomRadio
                  ? { ...pointerStyle, ...endTimeMarginStyle }
                  : endTimeMarginStyle
              }
            >
              <label style={cursorStyle}>
                <DatePicker
                  id="ExpStopDate"
                  selected={
                    this.state.disablestdRadio ? this.state.endDate : null
                  }
                  minDate={this.state.ServerTime}
                  onChange={this.handleChange2}
                  dateFormat={UserFormat}
                  utcOffset={0}
                  showDisabledMonthNavigation
                  value={this.state.endDate}
                  className={
                    this.state.disablecustomRadio
                      ? "workorderedit-dropdown pm_bg_color Pm_Full_Width"
                      : !this.state.isCustomEndDateEmpty && this.state.IsValid
                      ? "workorderedit-dropdown Pm_Full_Width"
                      : "errorhighlight workorderedit-dropdown Pm_Full_Width"
                  }
                />

                <img
                  src={CalendarGif}
                  alt="Trane Logo"
                  className="link_cursor"
                  style={{ paddingLeft: "10px" }}
                />
              </label>
            </div>
            <Icon
              name="exclamation triangle"
              style={
                this.state.IsValid && !this.state.isCustomEndDateEmpty
                  ? { display: "none" }
                  : {
                      color: "red",
                      "padding-left": "8px",
                      "padding-right": "14px",
                      "padding-top": "4px",
                    }
              }
            />
          </Col>
          <Col sm={{ size: 6 }}>
            <Label style={labelStyle} className="workorderlbl">
              End Time
            </Label>
            <label
              style={
                this.state.disablecustomRadio
                  ? { ...pointerStyle, ...cursorStyle, ...endTimeMarginStyle }
                  : { ...cursorStyle, ...endTimeMarginStyle }
              }
              className={
                this.state.IsValid && !this.state.isCustomStopTimeEmpty
                  ? ""
                  : "errorhighlight"
              }
            >
              <TimePicker
                ref="Time_in_timepicker"
                id="ExFStopTime"
                onChange={this.handleValueChange2}
                use12Hours={Is12HrFormat}
                format={Is12HrFormat ? "h:mm A" : "HH:mm"}
                value={this.state.stopTime}
                showSecond={false}
                open2={this.state.open2}
                onOpen={this.setOpen2}
                onClose={this.setClose2}
                style={{ width: "100%" }}
                focusOnOpen
              />
              <div className="pm_timerdiv" style={{ marginTop: "-12%" }}>
                <FaClock
                  className="pm_calendarbox"
                  width="17px"
                  height="17px"
                />
              </div>
            </label>
            <Icon
              name="exclamation triangle"
              style={
                this.state.IsValid && !this.state.isCustomStopTimeEmpty
                  ? { display: "none" }
                  : {
                      color: "red",
                      "padding-left": "8px",
                      "padding-right": "14px",
                      "padding-top": "0px",
                    }
              }
            />
          </Col>
        </FormGroup>

        {/*Button*/}
        <FormGroup row className="report_buttons">
          <Col sm={{ size: 12 }}>
            <hr />
            <Label
              style={{ position: "absolute", marginBottom: "0px", bottom: "0" }}
              className="link-cursor-underline"
              onClick={this.OnCancel}
            >
              Cancel
            </Label>
            <Button
              style={{ float: "right", marginRight: "0px" }}
              className="btn-success btn-md"
              disabled={this.state.IsNextDisabled}
              onClick={() => {
                this.OnNext("2");
              }}
            >
              Next
            </Button>
          </Col>
        </FormGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
    UserPreference_response: state.userPreferencesRootReducer.UserPreference,
    OnPremises: state.authService.IsOnPremise,
    ReportsList: state.ManageReportsRootReducer.MangeReportslist,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllResources: () => dispatch(getAllResources()),
    getReportsList: () => dispatch(getReportsList()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExportFormat);
//export default (ExportFormat);
